module.exports = __webpack_public_path__ + "img/module-booking.97043fda.svg";